import { isAdoName } from "@ttc-spectree/toolbox-contract";
import type { WorkItemProject } from "@/lib/api/work-items";

/**
 * The ADO projects an Admin can still set up: those the Admin's token lists
 * that no grooming config covers (names compare case-insensitively), whose
 * names the config accepts, de-duplicated and sorted case-insensitively.
 */
export function unconfiguredProjects(
  ado: readonly WorkItemProject[],
  configured: readonly { project: string }[]
): WorkItemProject[] {
  const taken = new Set(configured.map((c) => c.project.toLowerCase()));
  const seen = new Set<string>();
  const result: WorkItemProject[] = [];
  for (const project of ado) {
    const key = project.name.toLowerCase();
    if (taken.has(key) || seen.has(key)) continue;
    if (!isAdoName(project.name, "project")) continue;
    seen.add(key);
    result.push(project);
  }
  return result.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}

/** Projects whose name contains the trimmed query, ignoring case; an empty query keeps all. */
export function filterProjects(list: readonly WorkItemProject[], query: string): WorkItemProject[] {
  const wanted = query.trim().toLowerCase();
  return wanted ? list.filter((p) => p.name.toLowerCase().includes(wanted)) : [...list];
}
